import React, { useEffect, useRef } from "react";
import "./AboutUs.css";
import {
  FaIndustry,
  FaCube,
  FaLayerGroup,
  FaTools,
  FaCogs,
  FaDraftingCompass
} from "react-icons/fa";

function AboutPage() {

  const aboutRef = useRef(null);

  useEffect(() => {
    const sec = aboutRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) sec.classList.add("show");
        else sec.classList.remove("show");
      },
      { threshold: 0.2 }
    );

    observer.observe(sec);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="about_container" ref={aboutRef}>

      {/* HERO */}
      <section className="about_hero reveal_item delay_1">
        <h1>About VB Shah Inc</h1>
        <p>
          Advanced manufacturing solutions powered by precision engineering,
          additive technologies, and production expertise.
        </p>
      </section>

      {/* WHO WE ARE (SHORT & STRONG) */}
   <section className="about_who_section">
  <div className="about_who_container">

    <div className="about_who_left">
      <span className="about_tag">WHO WE ARE</span>
      <h2>
        Engineering Precision. <br />
        Manufacturing Excellence.
      </h2>

      <p>
        <strong>VB Shah Inc</strong> is a modern engineering and manufacturing
        company specializing in <span>3D Metal Printing</span>,
        <span> Plastic Prototyping</span>, <span>Mold Development</span>,
        <span> Injection Molding</span>, and
        <span> CAD-based Manufacturing Solutions</span>.
      </p>

      <p>
        We deliver precision-driven components for industrial, OEM,
        and export-grade applications with a strong focus on
        quality, efficiency, dimensional accuracy, and reliability.
      </p>

      <p>
        With advanced manufacturing capabilities and a skilled technical team,
        we transform concepts into high-performance engineered products —
        from design consultation and CAD modeling to prototyping and
        full-scale production.
      </p>
    </div>

    <div className="about_who_right">
      <div className="highlight_box">
        <h3>What Sets Us Apart</h3>
        <ul>
          <li>✔ Advanced Additive Manufacturing Technology</li>
          <li>✔ High-Tolerance Mold & Tooling Solutions</li>
          <li>✔ End-to-End Project Execution</li>
          <li>✔ Export-Grade Quality Standards</li>
          <li>✔ Optimized Lead Times & Cost Efficiency</li>
        </ul>
      </div>
    </div>

  </div>

  {/* Stats Row */}
  <div className="about_stats_row">
    <div>
      <h3>16+</h3>
      <p>Years Experience</p>
    </div>
    <div>
      <h3>1120+</h3>
      <p>Projects Delivered</p>
    </div>
    <div>
      <h3>250+</h3>
      <p>Satisfied Clients</p>
    </div>
    <div>
      <h3>100%</h3>
      <p>Quality Commitment</p>
    </div>
  </div>

</section>


      {/* WORK AREAS */}
      <section className="work_section reveal_item delay_3">
        <h2>Our Work Areas</h2>

        <div className="work_grid">

          <div className="work_card">
            <FaIndustry className="work_icon" />
            <h3>Metal 3D Printing (DMLS)</h3>
            <p>
              Stainless steel, aluminum & titanium printing
              for industrial-grade components.
            </p>
          </div>

          <div className="work_card">
            <FaCube className="work_icon" />
            <h3>Plastic 3D Printing</h3>
            <p>
              FDM & SLA printing using ABS, PLA, Nylon,
              PETG & engineering polymers.
            </p>
          </div>

          <div className="work_card">
            <FaLayerGroup className="work_icon" />
            <h3>Mold Making & Tooling</h3>
            <p>
              Custom molds with high accuracy,
              optimized design & long tool life.
            </p>
          </div>

          <div className="work_card">
            <FaTools className="work_icon" />
            <h3>Injection Molding</h3>
            <p>
              High-volume plastic production with
              tight tolerances & stable quality.
            </p>
          </div>

          <div className="work_card">
            <FaCogs className="work_icon" />
            <h3>Rapid Prototyping</h3>
            <p>
              Fast prototype manufacturing for
              testing & production validation.
            </p>
          </div>

          <div className="work_card">
            <FaDraftingCompass className="work_icon" />
            <h3>Design & CAD Engineering</h3>
            <p>
              Complete CAD modeling, drawing support
              & manufacturing optimization.
            </p>
          </div>

        </div>
      </section>

    </div>
  );
}

export default AboutPage;
